/* eslint-disable max-len */
import React from "react"

import BaseSvgIcon from "../Base"

const PerksFill = (props) => (
  <BaseSvgIcon {...props} viewBox="0 0 24 24">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.5128 3.97555H14.725C15.4575 2.89421 15.6659 1.80628 15.1544 1.29199C15.0498 1.19223 14.9273 1.11521 14.794 1.0654C14.6606 1.01559 14.5191 0.993996 14.3776 1.00187C13.466 1.09985 12.6111 1.51022 11.9463 2.16892C11.2794 1.50974 10.4223 1.09941 9.50867 1.00187C9.36717 0.993247 9.22546 1.01449 9.092 1.06434C8.95854 1.11419 8.83607 1.19161 8.73191 1.29199C8.22039 1.80628 8.42879 2.89421 9.16134 3.97555H10.5128ZM21.1033 6.06567H13.0199V9.22397H20.9959C21.2611 9.22397 21.5156 9.11442 21.7037 8.91924C21.8918 8.72406 21.9984 8.45909 22 8.18219V7.10086C21.9997 6.84304 21.9079 6.59449 21.7422 6.40328C21.5766 6.21207 21.3489 6.09178 21.1033 6.06567ZM3.55527 21.6949C3.36815 21.4995 3.26303 21.2345 3.26303 20.9582V11.3141H11.018V22H4.26082C3.99619 22 3.74239 21.8902 3.55527 21.6949ZM13.0199 22H19.7581C20.0228 22 20.2766 21.8902 20.4637 21.6949C20.6508 21.4995 20.7559 21.2345 20.7559 20.9582V11.3141H13.0199V22ZM2.90306 6.0591H10.1465V6.0657H11.018V9.22399H2.99779C2.73316 9.22399 2.47937 9.11423 2.29225 8.91886C2.10512 8.72349 2 8.45851 2 8.18222V7.10088C2.0003 6.84132 2.09282 6.5911 2.25964 6.39866C2.42646 6.20621 2.65572 6.08522 2.90306 6.0591Z"
      fill="#242425"
    />
  </BaseSvgIcon>
)

export default PerksFill
